export default __webpack_public_path__ + "static/media/coral-mountain-aerial-0665-2400x1350.75643db2.jpg";